import z from "zod";

import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { createComponentSchemas } from "@shared/content-types/utils";

const BackgroundMediaBaseSchema = z.object({
  type: z.enum(["image", "video"]).default("image"),
  image: StrapiMediaSchema.nullable().optional(),
  video: StrapiMediaSchema.nullable().optional(),
});

export const BackgroundMediaSchema = createComponentSchemas(
  "ui.background-media",
  BackgroundMediaBaseSchema,
);
